export const apiUrls = {
  completion: {
    
    create: {
      url: () => `/api/Completion/Create`,
    },
    get: {
      url: () => `/api/Completion/GetCompletions`,
    }
  },
  error:
    "https://defaulta096cfbadb7b4c9c9506d8e91da824.ee.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/d3911e8e411442209086fb35ba00270e/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=M7yY3z2kY4KNZACn8U42Aq2z_51X5nrvQ_WaVPeN4Ac",
  reports: {
    byCompanyId: {
      url: (companyId: string | number) => `/api/reports/${companyId}`,
    },
    url: () => `/api/reports`,
  },
  SigningSession: {
    signableDocuments: (companyId: string | number) =>
      `/api/File/ByCompanyId/${companyId}`,
    start: () => `/api/SigningSession/start`,
    sign: (signingSessionId: number | string) =>
      `/api/SigningSession/Sign/${signingSessionId}`,
  },

  groups: "/api/Groups",
  mapUsersToGroups: "/api/Groups/MapGroupUsers",
  file: {
    create: {
      url: () => `/api/File`,
    },
    list: {
      url: (companyId: string | number) => `/api/File/ByCompanyId/${companyId}`,
    },
    delete: {
      url: (fileId: number | string) => `/api/File/${fileId}`,
    },
  },
  assignment: {
    company: {
      url: (companyId: string | number) =>
        `/api/Assignment/GetByCompanyId/${companyId}`,
    },
    byInspectionId: {
      url: (deviationId: string | number) =>
        `/api/Assignment/GetByDeviationId/${deviationId}`,
    },
    user: {
      url: (userId: string | number) => `/api/Assignment/GetByUserId/${userId}`,
    },
    group: {
      url: (groupId: string | number) =>
        `/api/Assignment/GetByGroupId/${groupId}`,
    },
    byId: {
      url: (id: string | number) => `/api/Assignment/${id}`,
    },
    create: {
      url: () => `/api/Assignment`,
    },
  },
  features: {
    company: {
      url: (companyId: string | number) =>
        `/api/Feature/GetByCompanyId/${companyId}`,
    },
  },
  listBlobs: {
    url: (companyId: string | number) => `${companyId}/`,
  },
  getSasToken: {
    url: (companyId: string | number) =>
      `/api/Deviation/Image/token/${companyId}`,
  },
  createProjectVariation: {
    path: "/api/Deviation",
    url: () => `/api/Deviation`,
  },
  listFiles: {
    url: (companyId: string | number) =>
      `/api/deviation/image/${companyId}/list?fileName=124`,
  },

  getProjectVariations: {
    url: (companyId) => `/api/ProjectVariation/${companyId}`,
  },
  getDeviations: {
    url: (companyId) => `/api/Deviation/GetByCompanyId/${companyId}`,
  },
  getProjectVariationById: {
    url: (companyId, id) => `/api/Deviation/GetById/${companyId}/${id}`,
  },
  getDeviationsByInspectionId: {
    url: (inspectionId) => `/api/Deviation/GetByInspectionId/${inspectionId}`,
  },
  getProjectVariationImagesList: {
    url: (companyId, id) => `/api/Deviation/Image/${companyId}/${id}`,
  },
  getProjectVariationImageContent: {
    url: (companyId, id, filename) =>
      `/api/Deviation/Image/${companyId}/${id}?filePath=${filename}`,
  },
  updateProjectVariation: { url: () => "/api/Deviation" },
  image: {
    delete: (
      companyId: number | string,
      variationId: number | string,
      filename: string | number
    ) => `/api/ProjectVariation/${companyId}/${variationId}/images/${filename}`,
    url: (
      companyId: number | string,
      variationId: number | string,
      filename: string | number
    ) => `/api/ProjectVariation/${companyId}/${variationId}/images/${filename}`,
  },
  me: "/api/Users/Me",
  companies: "/api/Companies",
  usersByCompanyId: {
    url: (companyId) => `/api/Users/GetByCompanyId/${companyId}`,
  },
  userById: {
    url: (id) => `/api/Users/${id}`,
  },
  users: `/api/Users`,
  companyById: { url: (id) => `/api/Companies/${id}` },
  deviationTypes: "/api/ProjectVariation-deviationTypes",
  claimTypes: "/api/ProjectVariation-claimType",
  exitCategories: "/api/ProjectVariation-exitCategory",
  status: "/api/ProjectVariation-status",
  getTokenFromUid: (uid) => `/exchangeToken/${uid}`,
  getGroupsByCompanyId: {
    url: (companyId) => `/api/Groups/GetByCompanyId/${companyId}`,
  },
  deleteVariationById: {
    url: (variationId) => `/api/Deviation/${variationId}`,
  },
};
